export const translations = {
    en: {
        brand: "Faiha Co-op",
        tagline: "Fresh groceries, delivered with care",
        nav_home: "Home",
        nav_shop: "Shop",
        nav_categories: "Categories",
        nav_track: "Track Order",
        search_placeholder: "Search for products, brands...",
        all_products: "All Products",
        featured: "Featured",
        on_sale: "On Sale",
        shop_by_category: "Shop by Category",
        view_all: "View all",
        add_to_cart: "Add to Cart",
        added: "Added",
        out_of_stock: "Out of Stock",
        in_stock: "In stock",
        cart: "Cart",
        your_cart: "Your Cart",
        cart_empty: "Your cart is empty",
        cart_empty_sub: "Add some fresh products to get started",
        subtotal: "Subtotal",
        discount: "Discount",
        delivery: "Delivery",
        free: "FREE",
        total: "Total",
        checkout: "Checkout",
        continue_shopping: "Continue Shopping",
        proceed_checkout: "Proceed to Checkout",
        delivery_details: "Delivery Details",
        customer_details: "Customer Details",
        payment_method: "Payment Method",
        full_name: "Full Name",
        phone: "Phone Number",
        email: "Email (optional)",
        address: "Address",
        area: "Area / Block",
        notes: "Order Notes (optional)",
        delivery_slot: "Preferred Delivery Slot",
        cod: "Cash",
        cod_desc: "Pay with cash",
        knet: "KNET",
        knet_desc: "Pay securely with your KNET card",
        temporarily_unavailable: "Temporarily unavailable",
        enter_name_phone: "Please enter your name and phone number",
        coupon: "Coupon Code",
        apply: "Apply",
        coupon_invalid: "Invalid or expired coupon.",
        coupon_applied: "Coupon applied",
        remove: "Remove",
        my_account: "My Account",
        sign_in: "Sign In",
        create_account: "Create Account",
        account_subtitle: "Sign in to track your orders and check out faster.",
        password: "Password",
        login_btn: "Log In",
        register_btn: "Create Account",
        new_customer: "New customer?",
        have_account: "Already have an account?",
        min_password: "Password must be at least 6 characters.",
        account_created: "Account created",
        welcome_back: "Welcome back",
        logout: "Log Out",
        profile: "Profile",
        saved_addresses: "Saved Addresses",
        address: "Address",
        add_address: "Add address",
        save_changes: "Save Changes",
        saved: "Saved",
        order_history: "Order History",
        delete_account: "Delete Account",
        delete_account_desc: "Permanently delete your account and personal data.",
        delete_account_title: "Delete your account?",
        delete_account_warning: "This cannot be undone. Your login, profile and saved addresses will be permanently deleted. Your past orders are kept for our records, but your name, phone number and other personal details are removed from them.",
        delete_account_password: "Enter your password to confirm",
        delete_account_confirm: "Delete my account",
        delete_cancel: "Cancel",
        delete_wrong_password: "Incorrect password.",
        delete_blocked_open_orders: "You cannot delete your account while an order is in progress. Please try again once your order is completed or cancelled.",
        account_deleted: "Your account has been deleted.",
        no_orders: "No orders yet",
        order_history_guest_desc: "Enter your phone number to view your order history",
        order_history_secure: "Your phone number is only used to retrieve your orders.",
        view_orders: "View Orders",
        enter_phone: "Please enter your phone number",
        place_order: "Place Order",
        order_summary: "Order Summary",
        order_placed: "Order Placed Successfully!",
        order_confirmed_sub: "Thank you for shopping with Faiha Co-op",
        order_number: "Order Number",
        order_status: "Order Status",
        track_your_order: "Track Your Order",
        enter_order_no: "Enter your order number",
        track: "Track",
        refresh_status: "Refresh Status",
        items: "Items",
        qty: "Qty",
        admin_panel: "Admin Panel",
        login: "Login",
        logout: "Logout",
        language: "العربية",
        free_delivery_over: "Free delivery on orders over",
        min_order: "Minimum order",
        status_pending: "Pending",
        status_confirmed: "Confirmed",
        status_processing: "Processing",
        status_delivered: "Delivered",
        status_cancelled: "Cancelled",
        loading: "Loading...",
        no_products: "No products found",
        filters: "Filters",
        sort_by: "Sort by",
        sort_featured: "Featured",
        sort_price_asc: "Price: Low to High",
        sort_price_desc: "Price: High to Low",
        sort_name: "Name",
        processing_payment: "Processing Payment",
        knet_gateway: "KNET Payment Gateway",
        simulate_success: "Simulate Successful Payment",
        simulate_fail: "Simulate Failed Payment",
        payment_amount: "Amount to Pay",
        hero_cta: "Shop Fresh Now",
        shop_now: "Shop Now",
        company: "Company",
        nav_about: "About Us",
        nav_contact: "Contact Us",
        privacy_policy: "Privacy Policy",
        terms: "Terms & Conditions",
        footer_email_label: "Email",
        footer_hours_label: "Business Hours",
        hours_24: "Open 24 Hours",
        // Shared labels for the corporate/info pages
        label_organization: "Organization",
        label_website: "Website",
        label_phone: "Phone",
        label_email: "Email",
        label_hours: "Business Hours",
        legal_name: "AL-FAIHA CO-OPERATIVE SOCIETY",
        // About page
        about_badge: "Official Cooperative Society",
        about_title: "About AL-FAIHA CO-OPERATIVE SOCIETY",
        about_intro: "Faiha Store is the official online shopping platform of AL-FAIHA CO-OPERATIVE SOCIETY — a trusted cooperative society serving families across Kuwait with quality products and a convenient digital shopping experience.",
        about_who_title: "Who We Are",
        about_who_body: "AL-FAIHA CO-OPERATIVE SOCIETY is a leading cooperative society in Kuwait, providing groceries, bakery products, beverages, coffee, household products, fresh food, and daily essentials to the local community. Faiha Store brings this trusted cooperative online.",
        about_mission_title: "Our Mission",
        about_mission_body: "Our mission is to provide high-quality products, excellent customer service, and convenient digital shopping experiences for every household we serve — combining the values of a community cooperative with modern online shopping.",
        about_offer_title: "What We Offer",
        offer_groceries: "Groceries",
        offer_bakery: "Bakery Products",
        offer_beverages: "Beverages",
        offer_coffee: "Coffee",
        offer_household: "Household Products",
        offer_fresh: "Fresh Food",
        offer_essentials: "Daily Essentials",
        about_legal_label: "Official Legal Entity",
        about_owned_by: "Faiha Store is owned and operated by AL-FAIHA CO-OPERATIVE SOCIETY.",
        // Contact page
        contact_intro: "We're here to help. Reach AL-FAIHA CO-OPERATIVE SOCIETY through any of the channels below, or send us a message and our team will get back to you.",
        contact_getintouch: "Get in Touch",
        contact_sendmsg: "Send a Message",
        form_name: "Name",
        form_subject: "Subject",
        form_message: "Message",
        form_name_ph: "Your full name",
        form_subject_ph: "How can we help?",
        form_message_ph: "Write your message here…",
        contact_send_btn: "Send Message",
        contact_validation: "Please enter your name, email, and message.",
        contact_opening: "Opening your email app to send the message…",
        contact_default_subject: "Website Enquiry",
        contact_location: "Our Location",
        contact_location_sub: "AL-FAIHA CO-OPERATIVE SOCIETY, Kuwait",
        // Privacy Policy
        pp_s1_title: "Our Privacy Commitment",
        pp_s1_body: 'AL-FAIHA CO-OPERATIVE SOCIETY ("we", "us", or "Faiha Store") is committed to protecting the privacy of every customer who uses our online shopping platform. This Privacy Policy explains what information we collect, how we use it, and the steps we take to keep it safe.',
        pp_s2_title: "Customer Information We Collect",
        pp_s2_body: "To process your orders and provide our services, we may collect the following information:",
        pp_s2_li1: "Name and contact details (phone number and email address).",
        pp_s2_li2: "Delivery address and area details.",
        pp_s2_li3: "Order history and shopping preferences.",
        pp_s2_li4: "Account credentials for registered customers.",
        pp_s2_after: "We collect this information only to fulfil your orders, provide customer support, and improve your shopping experience.",
        pp_s3_title: "Cookies",
        pp_s3_body: "Our website and app use only essential first-party cookies and similar technologies — to keep you signed in and to remember the items in your cart. We do not use analytics, advertising, or third-party tracking cookies. You can control or disable cookies through your browser settings; however, some features of the store may not function properly if cookies are disabled.",
        pp_s4_title: "Payment Security",
        pp_s4_body: "All payments are processed through secure, trusted payment gateways. We do not store your full card or KNET details on our servers. Payment transactions are encrypted and handled by authorized payment providers in accordance with applicable security standards.",
        pp_s5_title: "Data Protection",
        pp_s5_body: "We apply appropriate technical and organizational measures to protect your personal information against unauthorized access, disclosure, alteration, or loss. Access to customer data is restricted to authorized personnel only. We do not sell or rent your personal information to third parties. Information may be shared only with delivery and payment partners strictly as needed to complete your order, or where required by law.",
        pp_s6_title: "Contact Information",
        pp_s6_body: "If you have any questions about this Privacy Policy or how your information is handled, please contact AL-FAIHA CO-OPERATIVE SOCIETY:",
        pp_s6_li1: "Email: info@faihacoopkw.com",
        pp_s6_li2: "Phone: +965 1861000",
        pp_s6_li3: "WhatsApp: +965 90986000",
        pp_meta_updated: "Last updated: 21 July 2026",
        pp_s7_title: "Information We Do Not Collect",
        pp_s7_body: "We keep data collection to a minimum. The Faiha Store app does not access your device location (GPS), contacts, photos, camera, microphone, or files. We do not use third-party analytics, advertising, tracking, profiling, or session-recording technologies, and we do not build advertising profiles or share your data with advertising networks. We do not collect any special-category or sensitive personal data.",
        pp_s8_title: "How Long We Keep Your Information",
        pp_s8_body: "We keep your account and order information for as long as your account remains active, and afterwards only for the period required to complete deliveries, handle returns, and meet legal, tax, and accounting obligations under the laws of the State of Kuwait. When information is no longer needed, it is securely deleted or anonymised.",
        pp_s9_title: "Your Rights & Account Deletion",
        pp_s9_body: "You have control over your personal information. You may:",
        pp_s9_li1: "Access and update your account details at any time from the Account section of the app or website.",
        pp_s9_li2: "Request a copy of the personal data we hold about you.",
        pp_s9_li3: "Request correction of inaccurate information.",
        pp_s9_li4: "Request deletion of your account and associated personal data.",
        pp_s9_after: "You can delete your account yourself at any time: sign in, open Account, choose Delete Account and confirm with your password. This permanently deletes your login, profile and saved addresses. Your past orders are kept for our sales and accounting records (and where the law requires), but the personal details on them — name, phone number, email, shareholder number, vehicle details and notes — are removed. An account cannot be deleted while one of its orders is still being processed; please try again once the order is completed or cancelled. You can also email us at info@faihacoopkw.com or contact us on WhatsApp at +965 90986000 from the phone number on your account, and we will delete your account and personal data within 30 days. Copies of our system backups may still contain your data until they are automatically replaced, which takes up to 30 days. Deleting your account ends your access to your Faiha Store account.",
        pp_s10_title: "Children's Privacy",
        pp_s10_body: "Faiha Store is intended for a general audience and for customers of AL-FAIHA CO-OPERATIVE SOCIETY. It is not directed at children under 13, and we do not knowingly collect personal information from children. If you believe a child has provided us with personal information, please contact us and we will delete it.",
        pp_s11_title: "Changes to This Policy",
        pp_s11_body: "We may update this Privacy Policy from time to time. The \"Last updated\" date at the top of this page shows when it was last revised. Significant changes will be communicated within the app or on our website. Your continued use of Faiha Store after an update means you accept the revised policy.",
        // Terms & Conditions
        tc_s1_title: "Website Usage",
        tc_s1_body: "By accessing and using Faiha Store, the official online platform of AL-FAIHA CO-OPERATIVE SOCIETY, you agree to these Terms & Conditions. The website and its content are provided for lawful shopping purposes only. You agree not to misuse the site, interfere with its operation, or attempt unauthorized access to any part of the platform.",
        tc_s2_title: "Orders",
        tc_s2_body: "When you place an order, you make an offer to purchase the selected products at the listed price. All orders are subject to product availability and confirmation. We reserve the right to accept or decline any order, and to limit quantities. Prices and product availability may change without prior notice.",
        tc_s3_title: "Delivery",
        tc_s3_body: "We aim to deliver your order within the delivery area and time slots shown at checkout. Delivery times are estimates and may be affected by circumstances beyond our control. Please ensure your delivery address and contact details are accurate to avoid delays.",
        tc_s4_title: "Returns",
        tc_s4_body: "If you receive a product that is damaged, expired, or incorrect, please contact us promptly so we can resolve the issue. Fresh food and perishable items may be subject to specific return conditions. Refunds or replacements are handled in line with our customer service policy.",
        tc_s5_title: "Payments",
        tc_s5_body: "We accept payment via KNET and cash on delivery, as available at checkout. All online payments are processed through secure payment gateways. Orders are confirmed once payment is successfully received or, for cash orders, once the order is placed and confirmed.",
        tc_s6_title: "Customer Responsibilities",
        tc_s6_body: "You are responsible for providing accurate account, contact, and delivery information, and for keeping your account credentials secure. You agree to use the platform in good faith and to comply with all applicable laws when placing orders.",
        tc_s7_title: "Intellectual Property",
        tc_s7_body1: "All content on this website — including the name AL-FAIHA CO-OPERATIVE SOCIETY, the Faiha Store brand, logos, text, graphics, and images — is the property of AL-FAIHA CO-OPERATIVE SOCIETY and is protected by applicable intellectual property laws. You may not copy, reproduce, or distribute any content without prior written permission.",
        tc_s7_body2: "For any questions regarding these Terms & Conditions, please contact us at info@faihacoopkw.com.",
        // Product customization / add-ons
        customize_order: "Customize Your Order",
        required: "Required",
        select_one: "Select one",
        select_options: "Select options",
        select_required_options: "Please select the required options before adding to cart.",
        shareholder_number: "Shareholder Number (Optional)",
        fulfillment_type: "Collection Method",
        pickup: "Pickup",
        car_service: "Car Service",
        pickup_desc: "Collect inside the store",
        car_service_desc: "We bring items to your car",
        vehicle_details: "Vehicle Details",
        vehicle_number: "Vehicle Number",
        vehicle_color: "Vehicle Color",
        vehicle_number_required: "Vehicle number is required for car service",
        vehicle_color_required: "Vehicle color is required for car service",
        fulfillment_method: "Collection Method",
        status_NEW: "New",
        status_PREPARING: "Preparing",
        status_READY: "Ready",
        status_COMPLETED: "Completed",
        status_CANCELLED: "Cancelled",
        status_pending: "New",
        status_confirmed: "Preparing",
        status_processing: "Ready",
        status_delivered: "Completed",
        ready_for_pickup_message: "Your order is ready for collection.",
        ready_for_car_service_message: "Your order is ready. Please come to the Faiha Co-op parking area and wait in your vehicle.",
        car_service_arrived_button: "I Have Arrived",
        car_service_arrived_confirmation: "Thank you. Our staff has been notified that you have arrived.",
        car_service_arrived_instructions: "Please remain in your vehicle. Our staff will bring your order to you.",
        car_service_waiting_for_customer: "Waiting for Customer",
        car_service_customer_arrived: "🚗 CUSTOMER HAS ARRIVED",
        car_service_arrived_at: "Arrived at",
        notifications: "Notifications",
        notifications_empty: "No notifications",
        notification_new_order: "🔔 New Order",
        notification_customer_arrived: "🚗 Customer Arrived",
        notification_order_number: "Order #",
        notification_customer: "Customer",
        notification_fulfillment: "Fulfillment",
        notification_vehicle: "Vehicle",
        notification_payment: "Payment",
        notification_time: "Time",
        notification_mark_read: "Mark as read",
        notification_mark_all_read: "Mark all as read",
        app_download_title: "Download Our App",
        app_download_text: "Shop conveniently with Faiha Store on your iPhone or Android device.",
        app_download_short: "Get the Faiha Store app",
        app_store_alt: "Download on the App Store",
        google_play_alt: "Get it on Google Play",
    },
    ar: {
        brand: "جمعية الفيحاء",
        tagline: "بقالة طازجة تصل إليك بعناية",
        nav_home: "الرئيسية",
        nav_shop: "تسوق",
        nav_categories: "الأقسام",
        nav_track: "تتبع الطلب",
        search_placeholder: "ابحث عن المنتجات والعلامات التجارية...",
        all_products: "جميع المنتجات",
        featured: "مميزة",
        on_sale: "عروض",
        shop_by_category: "تسوق حسب القسم",
        view_all: "عرض الكل",
        add_to_cart: "أضف إلى السلة",
        added: "تمت الإضافة",
        out_of_stock: "نفذت الكمية",
        in_stock: "متوفر",
        cart: "السلة",
        your_cart: "سلة التسوق",
        cart_empty: "سلة التسوق فارغة",
        cart_empty_sub: "أضف بعض المنتجات الطازجة للبدء",
        subtotal: "المجموع الفرعي",
        discount: "الخصم",
        delivery: "التوصيل",
        free: "مجاني",
        total: "الإجمالي",
        checkout: "الدفع",
        continue_shopping: "متابعة التسوق",
        proceed_checkout: "متابعة إلى الدفع",
        delivery_details: "تفاصيل التوصيل",
        customer_details: "بيانات العميل",
        payment_method: "طريقة الدفع",
        full_name: "الاسم الكامل",
        phone: "رقم الهاتف",
        email: "البريد الإلكتروني (اختياري)",
        address: "العنوان",
        area: "المنطقة / القطعة",
        notes: "ملاحظات الطلب (اختياري)",
        delivery_slot: "وقت التوصيل المفضل",
        cod: "نقداً",
        cod_desc: "ادفع نقداً",
        knet: "كي نت",
        knet_desc: "ادفع بأمان باستخدام بطاقة كي نت",
        temporarily_unavailable: "غير متاح مؤقتاً",
        enter_name_phone: "الرجاء إدخال الاسم ورقم الهاتف",
        coupon: "رمز الخصم",
        apply: "تطبيق",
        coupon_invalid: "قسيمة غير صالحة أو منتهية الصلاحية.",
        coupon_applied: "تم تطبيق القسيمة",
        remove: "إزالة",
        my_account: "حسابي",
        sign_in: "تسجيل الدخول",
        create_account: "إنشاء حساب",
        account_subtitle: "سجّل الدخول لتتبع طلباتك وإتمام الشراء بشكل أسرع.",
        password: "كلمة المرور",
        login_btn: "دخول",
        register_btn: "إنشاء حساب",
        new_customer: "عميل جديد؟",
        have_account: "لديك حساب بالفعل؟",
        min_password: "يجب أن تكون كلمة المرور 6 أحرف على الأقل.",
        account_created: "تم إنشاء الحساب",
        welcome_back: "مرحباً بعودتك",
        logout: "تسجيل الخروج",
        profile: "الملف الشخصي",
        saved_addresses: "العناوين المحفوظة",
        address: "العنوان",
        add_address: "إضافة عنوان",
        save_changes: "حفظ التغييرات",
        saved: "تم الحفظ",
        order_history: "سجل الطلبات",
        delete_account: "حذف الحساب",
        delete_account_desc: "احذف حسابك وبياناتك الشخصية نهائياً.",
        delete_account_title: "هل تريد حذف حسابك؟",
        delete_account_warning: "لا يمكن التراجع عن هذا الإجراء. سيتم حذف بيانات الدخول والملف الشخصي والعناوين المحفوظة نهائياً. نحتفظ بطلباتك السابقة ضمن سجلاتنا، لكن يتم حذف اسمك ورقم هاتفك وبقية بياناتك الشخصية منها.",
        delete_account_password: "أدخل كلمة المرور للتأكيد",
        delete_account_confirm: "حذف حسابي",
        delete_cancel: "إلغاء",
        delete_wrong_password: "كلمة المرور غير صحيحة.",
        delete_blocked_open_orders: "لا يمكنك حذف حسابك أثناء وجود طلب قيد التنفيذ. يرجى المحاولة مرة أخرى بعد اكتمال طلبك أو إلغائه.",
        account_deleted: "تم حذف حسابك.",
        no_orders: "لا توجد طلبات بعد",
        order_history_guest_desc: "أدخل رقم هاتفك لمشاهدة سجل طلباتك",
        order_history_secure: "يتم استخدام رقم هاتفك فقط لاسترجاع طلباتك.",
        view_orders: "عرض الطلبات",
        enter_phone: "يرجى إدخال رقم الهاتف",
        place_order: "تأكيد الطلب",
        order_summary: "ملخص الطلب",
        order_placed: "تم تأكيد الطلب بنجاح!",
        order_confirmed_sub: "شكراً لتسوقك من جمعية الفيحاء",
        order_number: "رقم الطلب",
        order_status: "حالة الطلب",
        track_your_order: "تتبع طلبك",
        enter_order_no: "أدخل رقم الطلب",
        track: "تتبع",
        refresh_status: "تحديث الحالة",
        items: "المنتجات",
        qty: "الكمية",
        admin_panel: "لوحة التحكم",
        login: "تسجيل الدخول",
        logout: "تسجيل الخروج",
        language: "English",
        free_delivery_over: "توصيل مجاني للطلبات فوق",
        min_order: "الحد الأدنى للطلب",
        status_pending: "قيد الانتظار",
        status_confirmed: "مؤكد",
        status_processing: "قيد التجهيز",
        status_delivered: "تم التوصيل",
        status_cancelled: "ملغي",
        loading: "جاري التحميل...",
        no_products: "لا توجد منتجات",
        filters: "تصفية",
        sort_by: "ترتيب حسب",
        sort_featured: "المميزة",
        sort_price_asc: "السعر: من الأقل للأعلى",
        sort_price_desc: "السعر: من الأعلى للأقل",
        sort_name: "الاسم",
        processing_payment: "جاري معالجة الدفع",
        knet_gateway: "بوابة الدفع كي نت",
        simulate_success: "محاكاة دفع ناجح",
        simulate_fail: "محاكاة دفع فاشل",
        payment_amount: "المبلغ المطلوب",
        hero_cta: "تسوق الطازج الآن",
        shop_now: "تسوق الآن",
        company: "الشركة",
        nav_about: "من نحن",
        nav_contact: "اتصل بنا",
        privacy_policy: "سياسة الخصوصية",
        terms: "الشروط والأحكام",
        footer_email_label: "البريد الإلكتروني",
        footer_hours_label: "ساعات العمل",
        hours_24: "مفتوح ٢٤ ساعة",
        // Shared labels for the corporate/info pages
        label_organization: "المؤسسة",
        label_website: "الموقع الإلكتروني",
        label_phone: "الهاتف",
        label_email: "البريد الإلكتروني",
        label_hours: "ساعات العمل",
        legal_name: "جمعية الفيحاء التعاونية",
        // About page
        about_badge: "جمعية تعاونية رسمية",
        about_title: "عن جمعية الفيحاء التعاونية",
        about_intro: "متجر الفيحاء هو المنصة الرسمية للتسوق الإلكتروني لجمعية الفيحاء التعاونية — جمعية تعاونية موثوقة تخدم العائلات في جميع أنحاء الكويت بمنتجات عالية الجودة وتجربة تسوق رقمية مريحة.",
        about_who_title: "من نحن",
        about_who_body: "جمعية الفيحاء التعاونية هي جمعية تعاونية رائدة في الكويت، توفّر البقالة والمخبوزات والمشروبات والقهوة والمنتجات المنزلية والأطعمة الطازجة والاحتياجات اليومية للمجتمع المحلي. ويقدّم متجر الفيحاء هذه الجمعية الموثوقة عبر الإنترنت.",
        about_mission_title: "رسالتنا",
        about_mission_body: "تتمثّل رسالتنا في تقديم منتجات عالية الجودة وخدمة عملاء متميّزة وتجارب تسوّق رقمية مريحة لكل أسرة نخدمها — بما يجمع بين قيم الجمعية التعاونية والتسوّق الإلكتروني الحديث.",
        about_offer_title: "ماذا نقدّم",
        offer_groceries: "البقالة",
        offer_bakery: "المخبوزات",
        offer_beverages: "المشروبات",
        offer_coffee: "القهوة",
        offer_household: "المنتجات المنزلية",
        offer_fresh: "الأطعمة الطازجة",
        offer_essentials: "الاحتياجات اليومية",
        about_legal_label: "الكيان القانوني الرسمي",
        about_owned_by: "متجر الفيحاء مملوك ومُدار من قِبل جمعية الفيحاء التعاونية.",
        // Contact page
        contact_intro: "نحن هنا لمساعدتك. تواصل مع جمعية الفيحاء التعاونية عبر أي من القنوات أدناه، أو أرسل لنا رسالة وسيقوم فريقنا بالرد عليك.",
        contact_getintouch: "تواصل معنا",
        contact_sendmsg: "أرسل رسالة",
        form_name: "الاسم",
        form_subject: "الموضوع",
        form_message: "الرسالة",
        form_name_ph: "اسمك الكامل",
        form_subject_ph: "كيف يمكننا المساعدة؟",
        form_message_ph: "اكتب رسالتك هنا…",
        contact_send_btn: "إرسال الرسالة",
        contact_validation: "يرجى إدخال الاسم والبريد الإلكتروني والرسالة.",
        contact_opening: "يتم فتح تطبيق البريد لإرسال رسالتك…",
        contact_default_subject: "استفسار من الموقع",
        contact_location: "موقعنا",
        contact_location_sub: "جمعية الفيحاء التعاونية، الكويت",
        // Privacy Policy
        pp_s1_title: "التزامنا بالخصوصية",
        pp_s1_body: 'تلتزم جمعية الفيحاء التعاونية ("نحن" أو "متجر الفيحاء") بحماية خصوصية كل عميل يستخدم منصتنا للتسوق الإلكتروني. توضّح سياسة الخصوصية هذه ما هي المعلومات التي نجمعها وكيف نستخدمها والخطوات التي نتّخذها للحفاظ على أمانها.',
        pp_s2_title: "معلومات العملاء التي نجمعها",
        pp_s2_body: "لمعالجة طلباتك وتقديم خدماتنا، قد نجمع المعلومات التالية:",
        pp_s2_li1: "الاسم وبيانات التواصل (رقم الهاتف والبريد الإلكتروني).",
        pp_s2_li2: "عنوان التوصيل وتفاصيل المنطقة.",
        pp_s2_li3: "سجل الطلبات وتفضيلات التسوق.",
        pp_s2_li4: "بيانات الحساب للعملاء المسجّلين.",
        pp_s2_after: "نجمع هذه المعلومات فقط لتنفيذ طلباتك وتقديم الدعم للعملاء وتحسين تجربة تسوّقك.",
        pp_s3_title: "ملفات تعريف الارتباط",
        pp_s3_body: "يستخدم موقعنا وتطبيقنا ملفات تعريف ارتباط أساسية من الطرف الأول فقط والتقنيات المشابهة — لإبقائك مسجّل الدخول وتذكّر العناصر في سلّتك. ولا نستخدم أي ملفات تعريف ارتباط خاصة بالتحليلات أو الإعلانات أو التتبّع من أطراف ثالثة. يمكنك التحكم في ملفات تعريف الارتباط أو تعطيلها من إعدادات المتصفح؛ إلا أن بعض ميزات المتجر قد لا تعمل بشكل صحيح عند تعطيلها.",
        pp_s4_title: "أمان الدفع",
        pp_s4_body: "تتم معالجة جميع المدفوعات عبر بوابات دفع آمنة وموثوقة. لا نقوم بتخزين بيانات بطاقتك أو كي نت كاملةً على خوادمنا. وتتم معاملات الدفع بشكل مشفّر ومن خلال مزوّدي دفع معتمدين وفقاً لمعايير الأمان المعمول بها.",
        pp_s5_title: "حماية البيانات",
        pp_s5_body: "نطبّق تدابير تقنية وتنظيمية مناسبة لحماية معلوماتك الشخصية من الوصول غير المصرّح به أو الإفصاح أو التعديل أو الفقدان. والوصول إلى بيانات العملاء مقتصر على الموظفين المصرّح لهم فقط. نحن لا نبيع أو نؤجّر معلوماتك الشخصية لأي طرف ثالث. وقد تتم مشاركة المعلومات فقط مع شركاء التوصيل والدفع بالقدر اللازم لإتمام طلبك، أو حيثما يقتضي القانون ذلك.",
        pp_s6_title: "معلومات التواصل",
        pp_s6_body: "إذا كان لديك أي استفسار حول سياسة الخصوصية هذه أو طريقة التعامل مع معلوماتك، يرجى التواصل مع جمعية الفيحاء التعاونية:",
        pp_s6_li1: "البريد الإلكتروني: info@faihacoopkw.com",
        pp_s6_li2: "الهاتف: +965 1861000",
        pp_s6_li3: "واتساب: +965 90986000",
        pp_meta_updated: "آخر تحديث: 21 يوليو 2026",
        pp_s7_title: "معلومات لا نقوم بجمعها",
        pp_s7_body: "نحرص على تقليل جمع البيانات إلى أدنى حد. لا يصل تطبيق متجر الفيحاء إلى موقع جهازك (نظام تحديد المواقع GPS) أو جهات الاتصال أو الصور أو الكاميرا أو الميكروفون أو الملفات. ولا نستخدم أي تقنيات تحليلات أو إعلانات أو تتبّع أو تصنيف أو تسجيل للجلسات تابعة لأطراف ثالثة، ولا ننشئ ملفات تعريف إعلانية ولا نشارك بياناتك مع أي شبكات إعلانية. كما أننا لا نجمع أي بيانات شخصية حسّاسة أو من الفئات الخاصة.",
        pp_s8_title: "مدة الاحتفاظ بمعلوماتك",
        pp_s8_body: "نحتفظ بمعلومات حسابك وطلباتك طالما ظل حسابك نشطاً، وبعد ذلك فقط للمدة اللازمة لإتمام عمليات التوصيل ومعالجة الإرجاع والوفاء بالالتزامات القانونية والضريبية والمحاسبية بموجب قوانين دولة الكويت. وعندما لا تعود هذه المعلومات لازمة، يتم حذفها بشكل آمن أو إخفاء هويتها.",
        pp_s9_title: "حقوقك وحذف الحساب",
        pp_s9_body: "أنت تتحكّم في معلوماتك الشخصية. ويمكنك:",
        pp_s9_li1: "الاطلاع على تفاصيل حسابك وتحديثها في أي وقت من قسم الحساب في التطبيق أو الموقع.",
        pp_s9_li2: "طلب نسخة من بياناتك الشخصية التي نحتفظ بها.",
        pp_s9_li3: "طلب تصحيح أي معلومات غير دقيقة.",
        pp_s9_li4: "طلب حذف حسابك والبيانات الشخصية المرتبطة به.",
        pp_s9_after: "يمكنك حذف حسابك بنفسك في أي وقت: سجّل الدخول، وافتح قسم الحساب، واختر حذف الحساب ثم أكّد بكلمة المرور. يؤدي ذلك إلى حذف بيانات الدخول والملف الشخصي والعناوين المحفوظة نهائياً. نحتفظ بطلباتك السابقة ضمن سجلاتنا المتعلقة بالمبيعات والمحاسبة (وحيثما يقتضي القانون ذلك)، مع حذف بياناتك الشخصية منها، وهي: الاسم ورقم الهاتف والبريد الإلكتروني ورقم المساهم وبيانات المركبة والملاحظات. لا يمكن حذف الحساب أثناء وجود طلب قيد المعالجة؛ يرجى المحاولة مرة أخرى بعد اكتمال الطلب أو إلغائه. كما يمكنك مراسلتنا على info@faihacoopkw.com أو التواصل معنا عبر واتساب على +965 90986000 من رقم الهاتف المرتبط بحسابك، وسنقوم بحذف حسابك وبياناتك الشخصية خلال 30 يوماً. وقد تبقى نسخ من بياناتك في النسخ الاحتياطية لأنظمتنا إلى أن يتم استبدالها تلقائياً، وذلك خلال مدة تصل إلى 30 يوماً. علماً بأن حذف الحساب يؤدي إلى إنهاء وصولك إلى حسابك في متجر الفيحاء.",
        pp_s10_title: "خصوصية الأطفال",
        pp_s10_body: "متجر الفيحاء مخصّص لجمهور عام ولعملاء جمعية الفيحاء التعاونية، وهو غير موجّه للأطفال دون سن 13 عاماً، ولا نجمع عن قصد أي معلومات شخصية من الأطفال. وإذا كنت تعتقد أن طفلاً قد زوّدنا بمعلومات شخصية، يرجى التواصل معنا وسنقوم بحذفها.",
        pp_s11_title: "التغييرات على هذه السياسة",
        pp_s11_body: "قد نقوم بتحديث سياسة الخصوصية هذه من وقت لآخر. ويوضّح تاريخ \"آخر تحديث\" أعلى هذه الصفحة موعد آخر مراجعة لها. وسيتم الإبلاغ عن أي تغييرات جوهرية داخل التطبيق أو على موقعنا. واستمرارك في استخدام متجر الفيحاء بعد أي تحديث يعني موافقتك على السياسة المُعدّلة.",
        // Terms & Conditions
        tc_s1_title: "استخدام الموقع",
        tc_s1_body: "بدخولك واستخدامك متجر الفيحاء، المنصة الرسمية لجمعية الفيحاء التعاونية، فإنك توافق على هذه الشروط والأحكام. يُقدَّم الموقع ومحتواه لأغراض التسوق المشروعة فقط. وتوافق على عدم إساءة استخدام الموقع أو التدخل في تشغيله أو محاولة الوصول غير المصرّح به إلى أي جزء من المنصة.",
        tc_s2_title: "الطلبات",
        tc_s2_body: "عند تقديمك لطلب، فإنك تقدّم عرضاً لشراء المنتجات المحددة بالسعر المعروض. وتخضع جميع الطلبات لتوافر المنتجات والتأكيد. ونحتفظ بالحق في قبول أو رفض أي طلب وفي تحديد الكميات. وقد تتغيّر الأسعار ومدى توافر المنتجات دون إشعار مسبق.",
        tc_s3_title: "التوصيل",
        tc_s3_body: "نهدف إلى توصيل طلبك ضمن منطقة التوصيل والأوقات المعروضة عند إتمام الطلب. وأوقات التوصيل تقديرية وقد تتأثر بظروف خارجة عن إرادتنا. يرجى التأكد من دقة عنوان التوصيل وبيانات التواصل لتجنّب أي تأخير.",
        tc_s4_title: "الإرجاع",
        tc_s4_body: "إذا استلمت منتجاً تالفاً أو منتهي الصلاحية أو غير صحيح، يرجى التواصل معنا فوراً لنتمكّن من حل المشكلة. وقد تخضع الأطعمة الطازجة والمنتجات القابلة للتلف لشروط إرجاع محددة. وتتم عمليات الاسترداد أو الاستبدال وفقاً لسياسة خدمة العملاء لدينا.",
        tc_s5_title: "المدفوعات",
        tc_s5_body: "نقبل الدفع عبر كي نت والدفع نقداً عند الاستلام، حسب المتاح عند إتمام الطلب. وتتم معالجة جميع المدفوعات الإلكترونية عبر بوابات دفع آمنة. ويتم تأكيد الطلبات بمجرد استلام الدفع بنجاح، أو بمجرد تقديم الطلب وتأكيده بالنسبة للطلبات النقدية.",
        tc_s6_title: "مسؤوليات العميل",
        tc_s6_body: "أنت مسؤول عن تقديم معلومات دقيقة للحساب والتواصل والتوصيل، وعن الحفاظ على سرية بيانات حسابك. وتوافق على استخدام المنصة بحسن نية والالتزام بجميع القوانين المعمول بها عند تقديم الطلبات.",
        tc_s7_title: "الملكية الفكرية",
        tc_s7_body1: "جميع المحتويات على هذا الموقع — بما في ذلك اسم جمعية الفيحاء التعاونية وعلامة متجر الفيحاء والشعارات والنصوص والرسومات والصور — هي ملك لجمعية الفيحاء التعاونية ومحمية بموجب قوانين الملكية الفكرية المعمول بها. ولا يجوز نسخ أو إعادة إنتاج أو توزيع أي محتوى دون إذن خطي مسبق.",
        tc_s7_body2: "لأي استفسارات بخصوص هذه الشروط والأحكام، يرجى التواصل معنا عبر info@faihacoopkw.com.",
        // Product customization / add-ons
        customize_order: "خصص طلبك",
        fulfillment_type: "طريقة الاستلام",
        pickup: "الاستلام من المتجر",
        car_service: "خدمة السيارة",
        pickup_desc: "اجمع طلبك من داخل المتجر",
        car_service_desc: "نأتي بالطلب إلى سيارتك",
        vehicle_details: "تفاصيل السيارة",
        vehicle_number: "رقم السيارة",
        vehicle_color: "لون السيارة",
        vehicle_number_required: "رقم السيارة مطلوب لخدمة السيارة",
        vehicle_color_required: "لون السيارة مطلوب لخدمة السيارة",
        fulfillment_method: "طريقة الاستلام",
        status_NEW: "جديد",
        status_PREPARING: "جاري التحضير",
        status_READY: "جاهز",
        status_COMPLETED: "مكتمل",
        status_CANCELLED: "ملغى",
        status_pending: "جديد",
        status_confirmed: "جاري التحضير",
        status_processing: "جاهز",
        status_delivered: "مكتمل",
        ready_for_pickup_message: "طلبك جاهز للاستلام.",
        ready_for_car_service_message: "طلبك جاهز. يرجى الذهاب إلى منطقة انتظار السيارات في جمعية الفيحاء والانتظار في سيارتك.",
        car_service_arrived_button: "وصلت إلى المكان",
        car_service_arrived_confirmation: "شكراً لك. تم إخطار موظفينا بوصولك.",
        car_service_arrived_instructions: "يرجى البقاء في سيارتك. سيأتي موظفونا بطلبك إليك.",
        car_service_waiting_for_customer: "في انتظار العميل",
        car_service_customer_arrived: "🚗 العميل قد وصل",
        car_service_arrived_at: "وصل في",
        required: "مطلوب",
        select_one: "اختر واحداً",
        select_options: "اختر الخيارات",
        select_required_options: "يرجى اختيار الخيارات المطلوبة قبل الإضافة إلى السلة.",
        shareholder_number: "رقم المساهم (اختياري)",
        notifications: "الإشعارات",
        notifications_empty: "لا توجد إشعارات",
        notification_new_order: "🔔 طلب جديد",
        notification_customer_arrived: "🚗 العميل وصل",
        notification_order_number: "طلب رقم #",
        notification_customer: "العميل",
        notification_fulfillment: "الاستلام",
        notification_vehicle: "السيارة",
        notification_payment: "الدفع",
        notification_time: "الوقت",
        notification_mark_read: "تم الاطلاع",
        notification_mark_all_read: "تم الاطلاع على الكل",
        app_download_title: "حمّل تطبيقنا",
        app_download_text: "تسوّق بسهولة مع متجر الفيحاء على جهاز iPhone أو Android.",
        app_download_short: "حمّل تطبيق متجر الفيحاء",
        app_store_alt: "حمّله من App Store",
        google_play_alt: "احصل عليه من Google Play",
    },
};

export const statusKey = (s) => ({
    NEW: "status_NEW", PREPARING: "status_PREPARING", READY: "status_READY",
    COMPLETED: "status_COMPLETED", CANCELLED: "status_CANCELLED",
    // backward compatibility for old statuses
    pending: "status_NEW", confirmed: "status_PREPARING", processing: "status_READY",
    delivered: "status_COMPLETED", cancelled: "status_CANCELLED",
}[s] || "status_NEW");
